import React from 'react';
import { RaportSummaryCard } from '@/components/Raport/RaportSummaryCard/RaportSummaryCard';
// import * as AspectRatio from '@radix-ui/react-aspect-ratio';
import './style.css';
import { AspectRatio } from '@radix-ui/react-aspect-ratio';
import clsx from 'clsx';
import type { RaportHSPHeaderProps } from './RaportHSPHeader.types';

export const RaportHSPHeader: React.FC<RaportHSPHeaderProps> = ({
  vehicleBrand,
  vehicleModel,
  vinNumber,
  reportDate,
  downloadPdf,
  logoUrl,
  carImageUrl,
  handleSeeGallery,
  onDownloadPdf,
  pdfLoading,
  innerStats,
  i18n,
}) => {
  // i18n fallbacks
  const photoGalleryTitle = i18n?.photoGalleryTitle || 'Galeria zdjęć';
  const noVehiclePhotoMessage =
    i18n?.noVehiclePhotoMessage || 'Brak zdjęcia pojazdu';
  const viewGalleryText = i18n?.viewGalleryText || '(Zobacz galerię)';
  return (
    <div className="flex max-w-[1268px] flex-col-reverse items-center justify-start md:flex-row">
      {/* Sekcja ze zdjęciem samochodu */}
      {carImageUrl && (
        <div className="stack stack-top relative w-full rounded-lg md:h-[250px] md:w-[35vw] xl:w-[400px]">
          <div
            className="flex flex-col items-start rounded-[25px] bg-white p-5"
            style={{ filter: 'drop-shadow(0px 4px 4px rgba(0,0,0,0.25))' }}
          >
            <p className="mb-5 text-left text-xl font-semibold text-text-primary">
              {photoGalleryTitle}
            </p>
            <AspectRatio ratio={16 / 9}>
              <div className="relative h-full w-full overflow-hidden rounded-[25px]">
                {carImageUrl ? (
                  <img
                    src={carImageUrl}
                    alt={`${vehicleBrand} ${vehicleModel}`}
                    className="h-full w-full object-cover"
                  />
                ) : (
                  <div className="flex h-full w-full items-center justify-center bg-gray-200 text-gray-500">
                    {noVehiclePhotoMessage}
                  </div>
                )}
              </div>
            </AspectRatio>
          </div>
          <div
            className="relative rounded-[25px] bg-white shadow-card"
            style={{ filter: 'drop-shadow(0px 4px 4px rgba(0,0,0,0.25))' }}
          >
            <span
              className="absolute left-0 right-0 top-0 mx-auto cursor-pointer text-center text-xs font-medium text-primary lg:top-[-3%]"
              onClick={handleSeeGallery}
            >
              {viewGalleryText}
            </span>
          </div>
          <div
            className="rounded-[25px] bg-[#FFFFFF] shadow-card"
            style={{ filter: 'drop-shadow(0px 4px 4px rgba(0,0,0,0.25))' }}
          ></div>
        </div>
      )}

      <div
        className={clsx(
          'z-[1] w-1/2 flex-1',
          carImageUrl ? 'w-full md:-ml-[20px] lg:w-1/2' : 'w-full lg:w-full',
        )}
      >
        <RaportSummaryCard
          raportType="HSP"
          reportDate={reportDate}
          vin={vinNumber}
          logoUrl={logoUrl}
          downloadPdf={downloadPdf}
          vehicleBrand={vehicleBrand}
          innerStats={innerStats}
          vehicleModel={vehicleModel}
          pdfLoading={pdfLoading}
          onDownloadPdf={() => {
            return onDownloadPdf?.();
          }}
          onDownloadPhotos={() => {
            // Obsługa pobierania zdjęć
          }}
          i18n={i18n}
        />
      </div>
    </div>
  );
};
